import { SortDirection } from '../constants/locationSummaryColumns';

const toComparable = (value: string | number): string | number => {
  if (typeof value === 'number') return value;
  const parsed = Number(value);
  if (!Number.isNaN(parsed) && value.trim() !== '') return parsed;
  return value.toLowerCase();
};

export const compareValues = (
  left: string | number,
  right: string | number,
  direction: SortDirection,
): number => {
  const a = toComparable(left);
  const b = toComparable(right);

  if (a < b) return direction === 'asc' ? -1 : 1;
  if (a > b) return direction === 'asc' ? 1 : -1;
  return 0;
};
